export default __webpack_public_path__ + "static/media/c006-b.0b3bb7cf.png";